import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-ms-dynamics-dev',
  templateUrl: './hire-ms-dynamics-dev.component.html',
  styleUrls: ['./hire-ms-dynamics-dev.component.css']
})
export class HireMsDynamicsDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-ms-dynamics-dev/hire-ms-dynamics-dev.component.ts